<table mat-table [dataSource]="signatureRequests$ | async">

  <!-- ID Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef> ID </th>
    <td mat-cell *matCellDef="let element">
      <a [routerLink]="['/signature-requests', element.id]">{{element.id}}</a>
    </td>
  </ng-container>

  <!-- Created At Column -->
  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef> Creado </th>
    <td mat-cell *matCellDef="let element"> {{element.createdAt | date}} </td>
  </ng-container>

  <!-- Finalized At Column -->
  <ng-container matColumnDef="finalizedAt">
    <th mat-header-cell *matHeaderCellDef> Finalizado </th>
    <td mat-cell *matCellDef="let element"> {{element.finalizedAt ? (element.finalizedAt | date) : 'N/A'}} </td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Estado </th>
    <td mat-cell *matCellDef="let element"> 
      <signature-request-status-badge [status]="element.status" [fontSize]="'.8rem'"></signature-request-status-badge>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['id', 'createdAt', 'finalizedAt', 'status']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['id', 'createdAt', 'finalizedAt', 'status'];"></tr>
</table>
<mat-paginator
  [length]="(totalItems$ | async) ?? 0"
  [pageSize]="configuration.pageSize"
  [pageIndex]="configuration.currentPage - 1"
  (page)="onPageChange($event)" 
  [pageSizeOptions]="[10, 20, 50]">
</mat-paginator>  